import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    gestioneZoneBox: {
      display: "flex",
      gap: 2,
      flexDirection: "column",
    },
    btnBack: {
      textTransform: "none",
      padding: 0,
      backgroundColor: "transparent",
      color: "primary.main",
      "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
    },
    categoriesSelected: {
      backgroundColor: "#f9f9fc",
      padding: 2,
      minHeight: "350px",
      maxHeight: '500px',
      overflow: 'auto',
      borderRadius: 2,
    },
    containerTextAndButton: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      justifyContent: 'end',
      [breakpoints.between('xs', 'md')]: { maxWidth: '94%' },
      [breakpoints.up('lg')]: { maxWidth: 'calc(73% - 16px)' },
    },
    buttonAdd: (disable: boolean) => ({
      backgroundColor: "#1976d2",
      ...disable && {
        border: '1px solid grey'
      },
      color: "white",
      width: 59,
      height: 59,
      borderRadius: 1,
      "&:hover": {
        backgroundColor: "#357ae8",
      },
    }),
    categoryAndSubCategoryGrid: {
      /*  borderRight: { xs: 'none', sm: 'none', xl: '1px solid #E4E4E4' },
       paddingRight: 2, */
    },
    btnsContainer: {
      marginTop: {
        sm: 2,
        xl: 15
      },
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    containerNoCategories: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      color: colors.backgroundDark,
      '& .MuiSvgIcon-root': {
        fontSize: '40px'
      },
      '& .MuiTypography-root': {
        fontSize: '20px',
        maxWidth: '500px',
        textAlign: 'center',
        fontWeight: 'bold'
      },
    },
    img: {
      width: '150px',
      height: '200px',
    },
    conteinerClear:{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }
  }
}